module.exports = (window.Handlebars["default"] || window.Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<a href=\"/campaigns/contact/?id="
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.contactID : depth0), depth0))
    + "\" class=\"campaign-contact-link mr-3\">\n    <span class=\"fa fa-id-card text-info\"></span>\n</a>";
},"useData":true})